import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore, serverTimestamp } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions' // ✅ Tambahkan baris ini

// ✅ Konfigurasi Firebase Project kamu
const firebaseConfig = {
  apiKey: 'AIzaSyCCvbE0Jk0AopZJxH2wGGJK_dJziurJKUY',
  authDomain: 'aplikasi-pemesanan-jasa.firebaseapp.com',
  projectId: 'aplikasi-pemesanan-jasa',
  storageBucket: "aplikasi-pemesanan-jasa",
  messagingSenderId: '494671551102',
  appId: '1:494671551102:web:dd7572e3f842157972962f',
  measurementId: 'G-DNE0JRCK2H',
}

// ✅ Inisialisasi Aplikasi
const app = initializeApp(firebaseConfig)

// ✅ Koneksi Firestore dan Auth
export const auth = getAuth(app)
export const db = getFirestore(app)

// ✅ Storage langsung dari bucket
export const storage = getStorage(app)

// ✅ Tambahkan fungsi agar React bisa panggil Cloud Functions
export const functions = getFunctions(app, 'asia-southeast2') // 🔥 ini penting

// ⏰ Tambahan: Ekspor serverTimestamp agar bisa dipakai di ChatRoomPage
export { serverTimestamp }
